import ShppingCartHeading from "./shppingcartheading"
import React from 'react';
import { Icontainerprops } from "./shppingcartheadinginterface";

const ShppingCartHeadingContainer = (props: Icontainerprops) => {
    
    return (
        <ShppingCartHeading showKomatsuCreditHistory={props.showKomatsuCreditHistory}
            komatsuCreditHistoryButtonVisibility={props?.komatsuCreditHistoryButtonVisibility}
            komatsuCreditHistoryOnClick={props?.komatsuCreditHistoryOnClick}
            punchoutButtonVisibility={props.punchoutButtonVisibility}
             cartsDetails={props.cartsDetails} uploadOnClick={props.uploadOnClick} showPuchoutHistory={props.showPuchoutHistory} isPartNumber={props.isPartNumber} savedpartsOnClick={props.savedpartsOnClick} quotesOnClick={props.quotesOnClick} puchoutHistoryOnClick={props.puchoutHistoryOnClick} historyOnClick={props.historyOnClick} />
    )
}
export default ShppingCartHeadingContainer